import type { ClockResources } from './en-US.js';

export const ja: ClockResources = {
  nav: {
    clock: '打刻',
    records: '勤務記録',
    requests: '修正申請',
    approvals: '承認',
    team: 'チーム',
    schedules: '勤務予定',
  },
  clock: {
    now: '現在時刻（{{timeZone}}）',
    status: '状態',
    since: '{{time}} から',
    today: '本日の打刻',
    noPunches: '本日の打刻はまだありません。',
    recorded: '{{time}} に記録しました。',
    needsCorrection:
      '{{dates}} に開始した勤務は、出勤から24時間で自動退勤しました。実際の退勤時刻を修正申請してください。',
    requestCorrection: '修正を申請',
    endAgainHint: '退勤をもう一度押すと、退勤時刻が更新されます。',
    location: {
      title: '位置情報',
      granted: '位置情報の利用が許可されています。',
      prompt: '打刻時にブラウザが位置情報の利用を確認します。',
      denied:
        '位置情報の利用がブロックされています。打刻するにはブラウザの設定で許可してください。',
      unsupported: 'このブラウザでは位置情報を取得できません。',
      locating: '位置情報を取得しています…',
    },
    error: {
      title: '位置情報が必要です',
      denied:
        'このサイトでの位置情報の利用がブロックされています。ブラウザのサイト設定で位置情報を許可してから、もう一度お試しください。',
      unavailable:
        '位置情報を取得できませんでした。端末の位置情報サービスがオンになっていることを確認して、もう一度お試しください。',
      timeout:
        '位置情報の取得に時間がかかりすぎました。電波の良い場所に移動して、もう一度お試しください。',
      unsupported:
        'このブラウザでは位置情報を取得できません。別のブラウザまたは端末から打刻してください。',
    },
  },
  records: {
    title: '勤務記録',
    titleOf: '{{name}} さんの勤務記録',
    previousMonth: '前の月',
    nextMonth: '次の月',
    date: '日付',
    schedule: '予定',
    actual: '勤務時間帯',
    breaks: '休憩',
    worked: '実働',
    late: '遅刻',
    earlyLeave: '早退',
    overtime: '残業',
    holidayWork: '休日労働',
    notes: '備考',
    dayOff: '休日',
    missingPunch: '打刻漏れ',
    modified: '修正済み',
    pending: '申請中',
    outsideGeofence: '範囲外打刻',
    endUpdated: '退勤更新',
    autoEnded: '自動退勤',
    totals: '月間合計',
    calendar: 'カレンダー',
    daysWorked: '出勤日数',
    lateCount: '遅刻回数',
    earlyLeaveCount: '早退回数',
    missingPunches: '打刻漏れ',
    exportMonth: '月次（CSV）',
    exportYear: '年次（CSV）',
  },
  day: {
    back: '勤務記録に戻る',
    schedule: '予定',
    noSchedule: '予定なし',
    noRecord: 'この日の記録はありません。',
    breaks: '休憩',
    noBreaks: '休憩なし',
    punches: '打刻',
    showOnMap: '地図',
    evidence: '打刻の詳細（マネージャー・管理者用）',
    ip: 'IP アドレス',
    accuracy: '精度',
    geofence: 'ジオフェンス',
    nearestArea: '最寄りのエリア',
    distance: '距離',
    meters: '{{value}} m',
    requests: '修正申請',
    requestChange: '修正を申請',
  },
  request: {
    title: '修正申請',
    hint: '記録すべき時刻をすべての休憩を含めて入力してください。マネージャーの承認後に反映されます。',
    workDate: '勤務日',
    start: '開始',
    end: '終了',
    breaks: '休憩',
    addBreak: '休憩を追加',
    removeBreak: '休憩を削除',
    breakStart: '休憩開始',
    breakEnd: '休憩終了',
    reason: '理由',
    submit: '申請する',
  },
  requests: {
    title: '修正申請',
    empty: '申請はまだありません。',
    newRequest: '新規申請',
    withdraw: '取り下げ',
    requestedAt: '申請日時 {{time}}',
    reviewedBy: '{{name}}（{{time}}）',
    comment: 'コメント',
    requested: '申請内容',
    current: '現在の記録',
  },
  approvals: {
    title: '承認',
    empty: '承認待ちの申請はありません。',
    comment: 'コメント（任意）',
  },
  team: {
    title: 'チーム',
    today: '本日',
    month: '月間',
    group: 'グループ',
    allGroups: 'すべてのグループ',
    member: 'メンバー',
    state: '状態',
    since: '開始',
    warnings: '注意',
    outsideGeofence: '範囲外で打刻',
    needsCorrection: '修正が必要な勤務があります',
    pendingRequests: '申請 {{count}} 件',
    worked: '実働',
    daysWorked: '日数',
    overtime: '残業',
    late: '遅刻',
    missingPunches: '打刻漏れ',
    outsideDays: '範囲外',
    empty: 'メンバーがいません。',
  },
  schedules: {
    title: '勤務予定',
    group: 'グループ',
    groupDefault: 'グループの標準',
    individual: '個別の勤務予定',
    member: 'メンバー',
    effectiveFrom: '適用開始日',
    weekday: '曜日',
    workday: '勤務日',
    start: '開始',
    end: '終了',
    breakMinutes: '休憩（分）',
    overnightHint: '終了時刻が開始時刻以前の場合は、翌日に終了する勤務です。',
    versions: '履歴',
    inEffect: '適用中',
    empty: '勤務予定はまだありません。',
    saved: '勤務予定を保存しました。',
    useGroupDefault: '個別の勤務予定はありません。グループの標準が適用されます。',
  },
  geofences: {
    title: 'ジオフェンス',
    description:
      'グループのどの有効なエリアにも入っていない打刻は受け付けられますが、マネージャーと管理者に表示されます。',
    name: '名前',
    latitude: '緯度',
    longitude: '経度',
    radius: '半径（m）',
    active: '有効',
    add: 'エリアを追加',
    mapHint: '地図をクリックすると中心を移動できます。',
    empty: 'このグループのエリアはありません。',
  },
  audit: {
    title: '監査ログ',
    time: '日時',
    actor: '実行者',
    action: '操作',
    target: '対象',
    system: 'システム',
    actions: {
      ScheduleChanged: '勤務予定の変更',
      GeofenceChanged: 'ジオフェンスの変更',
      ModificationRequested: '修正申請の提出',
      ModificationApproved: '修正申請の承認',
      ModificationRejected: '修正申請の却下',
      ModificationCancelled: '修正申請の取り下げ',
      CsvExported: 'CSV 出力',
      LocalAdminGranted: '管理者の追加',
      LocalAdminRevoked: '管理者の削除',
    },
  },
};
